import { FC } from "react";
import Heading from "@components/primitives/heading/Heading";
import { Sizes } from "@utils/sizes";
import FormRow from "@components/primitives/form/FormRow";
import Button from "@components/primitives/button/Button";
import { useTranslation } from "react-i18next";
import useLogin from "@hooks/useLogin";
import { toast } from "react-toastify";

const Login: FC = () => {
  const login = useLogin();
  const { t } = useTranslation();

  const handleLogin = () => {
    toast.dismiss();
    login();
  };

  return (
    <>
      <Heading size={Sizes.xl}>
        {t("login.title", { ns: "authentication" })}
      </Heading>
      <p>{t("login.text", { ns: "authentication" })}</p>
      <br />
      <FormRow>
        <Button
          testId="login__azure"
          primary
          className="loginBox__button"
          onClick={handleLogin}
        >
          {t("login.azureButton", { ns: "authentication" })}
        </Button>
      </FormRow>
    </>
  );
};

export default Login;
